module.exports = __webpack_public_path__ + "static/img/gec_dyh.edb5b97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gecFooter/img/gec_dyh.jpg
// module id = xG+p
// module chunks = 1